module.exports = __webpack_public_path__ + "static/media/UniNeueThin.95800f79.ttf";